import {
  ServiceEventTicketPolicyFormDefaultValues,
  ServiceEventTicketPolicyFormProps,
  ServiceEventTicketPolicyFormRawValues,
  ServiceEventTicketPolicyFormType
} from "./ServiceEventTicketPolicyForm";
import {useTranslation} from "react-i18next";
import {useForm} from "@mantine/form";
import {getObjectId, isStringUndefinedOrBlank, ServiceEventTicketPolicyEntity} from "@ots-frontend/ots-data";
import {useApp} from "../../../providers/RegionProvider/RegionProvider";
import { useAuth } from "../../../providers/AuthProvider/AuthProvider";

export const toFormDefaultsFromServiceEventTicketPolicy = (policy: ServiceEventTicketPolicyEntity | undefined): ServiceEventTicketPolicyFormDefaultValues => {
  return {
    name: policy?.name,
    description: policy?.description,
    eventType: policy?.eventType,
    company: policy?.companyId,
    serviceType: policy?.serviceTypeId,
    triggerFacet: policy?.triggerFacet,
    triggerFromStatus: policy?.triggerFromStatus,
    triggerToStatus: policy?.triggerToStatus,
    minSeverity: policy?.minSeverity,
    category: policy?.category,
    freightType: policy?.freightTypeId,
    defaultQuantity: {
      number: policy?.defaultQuantity,
      units: policy?.defaultQuantityUom,
    },
    priority: policy?.priority,
    doNotUse: policy?.doNotUse,
  };
};

const getInitialValues = (defaultValues: ServiceEventTicketPolicyFormDefaultValues | undefined): ServiceEventTicketPolicyFormRawValues => {
  return {
    name: defaultValues?.name,
    description: defaultValues?.description,
    eventType: defaultValues?.eventType?.code,
    company: getObjectId(defaultValues?.company),
    serviceType: getObjectId(defaultValues?.serviceType),
    triggerFacet: defaultValues?.triggerFacet,
    triggerFromStatus: defaultValues?.triggerFromStatus,
    triggerToStatus: defaultValues?.triggerToStatus,
    minSeverity: defaultValues?.minSeverity,
    category: defaultValues?.category?.code,
    freightType: getObjectId(defaultValues?.freightType),
    defaultQuantity: defaultValues?.defaultQuantity?.number,
    defaultQuantityUom: defaultValues?.defaultQuantity?.units,
    priority: defaultValues?.priority,
    doNotUse: defaultValues?.doNotUse,
  };
}

export type UseServiceEventTicketPolicyFormProps = Pick<ServiceEventTicketPolicyFormProps, 'defaultValues'> & {}

export function useServiceEventTicketPolicyForm(props: UseServiceEventTicketPolicyFormProps): ServiceEventTicketPolicyFormType {
  const {
    defaultValues
  } = props

  const {appCategory} = useApp()
  const {companyId} = useAuth()

  const {t} = useTranslation(["common"])

  const form = useForm({
    initialValues: getInitialValues({
      ...defaultValues,
      company: defaultValues?.company ?? companyId,
      category: defaultValues?.category ?? appCategory,
      priority: defaultValues?.priority ?? 1000,
    }),
    validate: {
      name: (value) => !isStringUndefinedOrBlank(value) ? undefined : t("common.validation.required", "Required"),
      eventType: (value) => value ? undefined : t("common.validation.required", "Required"),
      company: (value) => value ? undefined : t("common.validation.required", "Required"),
      serviceType: (value) => value ? undefined : t("common.validation.required", "Required"),
      triggerFacet: (value) => value ? undefined : t("common.validation.required", "Required"),
      triggerToStatus: (value) => value ? undefined : t("common.validation.required", "Required"),
      category: (value) => value ? undefined : t("common.validation.required", "Required"),
      freightType: (value) => value ? undefined : t("common.validation.required", "Required"),
    },
  })

  return form
}
